module.exports = __webpack_public_path__ + "static/img/pc2.af9769e0.png";